import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetAuth } from '../../../Auth/AuthProvider';
// import { updateData } from '../../../Helpers/requests';clea

// import { convertDate } from '../../Helpers/helpers';

import {
  convertDate,
  defineTicketNumber,
  defineTicketNumberV2,
} from '../../../Helpers/helpers';

import { NoHeaderTableUpdate } from '../../../Helpers/requests';

import { ticketTabStyle } from '../../shared/commonStyle';

import { Button, Box } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';

function TechRepairTickets() {
  const navigateNew = useNavigate();

  const [data, setData] = useState([]); //data displayed in datagrid
  const [page, setPage] = useState(0); //Active page of table - starts at 0!
  const [filter, setFilter] = useState([]); //Current applied filter modal
  const [sort, setSort] = useState([]); //Current applied sorting modal
  const [loading, setLoading] = useState(false); //Loading indicator - used by datagrid
  const [activeRow, setActiveRow] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize, setPageSize] = useState(20); //Number of rows to display
  const [totalRows, setTotalRows] = useState(0); //Total Number of rows in set
  const [updateData, setUpdateData] = useState(0); //Increment to force update dataset
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications

  const [infoPlateData, setInfoPlateData] = useState({
    address: '',
    cabinet_type: '',
    category: '',
    date_completed: '',
    date_logged: '',
    id: 0,
    status: '',
    store_name: '',
    tech_name: '',
    ticket_num: '',
    ticket_type: '',
  });

  useEffect(() => {
    NoHeaderTableUpdate(
      {
        resource: `/api/technician`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
      },
      'technician'
    );
  }, [page, pageSize, sort, filter, updateData, enqNotification, logout]);

  const definedColumns = [
    {
      field: 'ticket_type',
      headerName: 'Ticket Nr.',
      minWidth: 180,
      flex: 1,
      editable: false,
      valueGetter: (row) => defineTicketNumber('repair', row.id, 5, 'R')
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 180,
      flex: 1,
      editable: false,
      // valueGetter: ({ value }) => ticketStatus(value),
    },
    {
      field: 'customer_category_name',
      headerName: 'Category',
      minWidth: 150,
      flex: 1,
      editable: false,
      // valueGetter: ({ value }) =>
      //   new Date(value)
      //     .toLocaleString('en-GB', { timeZone: 'UTC' })
      //     .slice(0, 10),
      // // valueGetter: ({ value }) => new Date(value).toString(),
    },
    {
      field: 'customer_name',
      headerName: 'Store Name',
      minWidth: 190,
      flex: 1,
      editable: false,
      //   valueGetter: ({ value }) =>
      //     value === undefined ? 1.0 : parseFloat(value),
      //
    },
    {
      field: 'date_logged',
      headerName: 'Date Logged',
      minWidth: 190,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) => convertDate(value, 0, 10),
    },

    //Custom "Actions" column - props.value is field value (id in this case)
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: 'left',

      renderCell: (props) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              navigateNew(`/tech/tech_repair_ticket_view`, {
                replace: true,
                state: props.row,
              });
            }}
          >
            Open
          </Button>
          {/* <Button
            sx={{ marginLeft: '5px' }}
            variant='outlined'
            size='small'
          
          >
            Stop
          </Button> */}
        </>
      ),
    },
  ];

  return (
    <Box style={{ minHeight: '75vh', maxWidth: '100%' }}>
      {/* <center> */}
      <Box style={{ height: '87.7vh', maxWidth: '100%', textAlign: 'center' }}>
        {/*Configure datagrid */}
        <DataGrid
          sx={ticketTabStyle}
          rows={data}
          rowCount={totalRows}
          loading={loading}
          pagination
          sortingMode='server'
          filterMode='server'
          onSortModelChange={(model) => {
            setPage(0);
            setSort(model);
          }}
          onFilterModelChange={(model) => {
            setPage(0);
            setFilter(model.quickFilterValues);
          }}
          page={page}
          pageSize={pageSize}
          paginationMode='server'
          onPageChange={(newPage) => {
            setPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            setPage(0);
            setPageSize(newPageSize);
          }}
          columns={definedColumns}
          onRowClick={(params) => {
            setActiveRow(params);
            // setInfoPlateData(params.row);
          }}
          onRowDoubleClick={(params) => {
            navigateNew(`/tech/tech_repair_ticket_view`, {
              replace: true,
              state: params.row,
            });
          }}
          rowsPerPageOptions={[20, 50, 100]}
          //   components={{ Toolbar: CustomCustomerToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          //   componentsProps={{
          //     toolbar: {
          //       updateOnclick: () => {
          //         setUpdateData((i) => i + 1);
          //       },
          //     },
          //   }}
        />
      </Box>

      <Box>
        {/* <div id='test' style={{ height: 200, width: '80%' }}>
          <br />
          <br />
          <Detailbox rowData={activeRow} />
          <br />
        </div> */}
        {/* </center> */}

        {/* 
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle600} md={modalStyle900} lg={modalStyle1024}>
          <SerialEditInfoCard
            modalData={modalData}
            closeModel={handleClose}
            modalMode={editOrSave}
          />
        </Box>
      </Modal> */}
      </Box>
    </Box>
  );
}

export default TechRepairTickets;
